import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import { Row, Col, Label } from "reactstrap";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import InfoIcon from "@mui/icons-material/Info";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import Radio from "@material-ui/core/Radio";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import DeleteIcon from "@material-ui/icons/Delete";
import { pink } from "@mui/material/colors";
import Switch from "@mui/material/Switch";
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Alert from "@mui/material/Alert";
import EditCred from "./Edit.js";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Credentials() {
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [searchitems, setSearchItems] = React.useState(0);

  const [subnav, setSubnav] = useState(false);

  const [selectedValue, setSelectedValue] = React.useState("os");

  const [state, setState] = React.useState({
    name: "",
    description: "",
    auth_method: "",
    username: "",
    password: "",
    ssh_key: "",
    os_type: "",
    provider: "",
    accesskeyid: "",
    secretaccesskey: "",
    clientid: "",
    secret: "",
    serviceaccjson: "",
    kubeconfig: "",
    kerberos: "no",
    domain_name: "",
    ad_server: "",
    errorMessage: "",
    delete_id: "",
    showPassword: false,
  });
  const showSubnav = () => {
    setSubnav(!subnav);
    if (subnav) {
      const id = "kerberos";
      setState((prevState) => ({
        ...prevState,
        [id]: "no",
      }));
    } else {
      const id = "kerberos";
      setState((prevState) => ({
        ...prevState,
        [id]: "yes",
      }));
    }
  };

  const [credlist, setCredlist] = useState([]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleChange1 = (event) => {
    const { value } = event.target;
    setSelectedValue(value);
    if (value === "kubernetes") {
      const id = "provider"
      setState((prevState) => ({
        ...prevState,
        [id]: value,
      }));  
    }
  };

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (selectedValue === "os") {
      if (
        ((state.username === "Administrator" ||
          state.username === "administrator") &&
          state.os_type === "windows") ||
        ((state.username === "root" || state.username === "Root") &&
          state.os_type === "linux")
      ) {
        if (state.os_type === "windows") {
          setState({
            errorMessage:
              "For security reasons Administrator user is not allowed in Windows!",
          });
        } else {
          setState({
            errorMessage:
              "For security reasons root user is not allowed in Linux!",
          });
        }
      } else {
        if (/^[A-Za-z][A-Za-z0-9-_.]*$/.test(state.username)) {
          if (state.os_type === "windows") {
            const register = {
              name: state.name,
              description: state.description,
              auth_method: "password",
              username: state.username,
              password: state.password,
              ssh_key: state.ssh_key,
              os_type: state.os_type,
              kerberos: state.kerberos,
              domain_name: state.domain_name,
              ad_server: state.ad_server,
              provider: "os",
              accesskeyid: state.accesskeyid,
              secretaccesskey: state.secretaccesskey,
              clientid: state.clientid,
              secret: state.secret,
              serviceaccjson: state.serviceaccjson,
              kubeconfig: state.kubeconfig,
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/credentials/`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
              },
              body: JSON.stringify(register),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.name) {
                  setOpen(!open);
                  window.location.href = "/admin/credentials";
                }
              })
              .catch((error) => {
                console.error(error);
                window.location.href = "/something_went_wrong";
              });
          } else {
            if (state.ssh_key) {
              const pemKey = state.ssh_key;
              var lines = pemKey.split("\n");
              var OpenkeyType = "";
              var EndkeyType = "";
              for (var i = 0; i < lines.length; i++) {
                if (lines[i] === "-----BEGIN RSA PRIVATE KEY-----") {
                  OpenkeyType = "RSAprivate";
                } else if (lines[i] === "-----BEGIN PRIVATE KEY-----") {
                  OpenkeyType = "PRIVATE";
                } else if (lines[i] === "-----BEGIN OPENSSH PRIVATE KEY-----") {
                  OpenkeyType = "OPENSSHprivate";
                } else if (lines[i] === "-----END RSA PRIVATE KEY-----") {
                  EndkeyType = "RSAprivate";
                } else if (lines[i] === "-----END PRIVATE KEY-----") {
                  EndkeyType = "PRIVATE";
                } else if (lines[i] === "-----END OPENSSH PRIVATE KEY-----") {
                  EndkeyType = "OPENSSHprivate";
                }
              }
              if (
                (OpenkeyType === "RSAprivate" && EndkeyType === "RSAprivate") ||
                (OpenkeyType === "PRIVATE" && EndkeyType === "PRIVATE") ||
                (OpenkeyType === "OPENSSHprivate" &&
                  EndkeyType === "OPENSSHprivate")
              ) {
                const register = {
                  name: state.name,
                  description: state.description,
                  auth_method: state.auth_method,
                  username: state.username,
                  password: state.password,
                  ssh_key: state.ssh_key,
                  os_type: state.os_type,
                  provider: "os",
                  accesskeyid: state.accesskeyid,
                  secretaccesskey: state.secretaccesskey,
                  clientid: state.clientid,
                  secret: state.secret,
                  serviceaccjson: state.serviceaccjson,
                  kubeconfig: state.kubeconfig,
                };
                fetch(`${process.env.REACT_APP_API_URL}/api/credentials/`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer " + window.localStorage.getItem("token"),
                  },
                  body: JSON.stringify(register),
                })
                  .then((response) => response.json())
                  .then((data) => {
                    if (data.name) {
                      setOpen(!open);
                      window.location.href = "/admin/credentials";
                    }
                  })
                  .catch((error) => {
                    console.error(error);
                    window.location.href = "/something_went_wrong";
                  });
              } else {
                setState({
                  errorMessage:
                    "Invalid key, Please enter the key in PEM format",
                });
              }
            } else {
              const register = {
                name: state.name,
                description: state.description,
                auth_method: state.auth_method,
                username: state.username,
                password: state.password,
                ssh_key: state.ssh_key,
                os_type: state.os_type,
                provider: "os",
                accesskeyid: state.accesskeyid,
                secretaccesskey: state.secretaccesskey,
                clientid: state.clientid,
                secret: state.secret,
                serviceaccjson: state.serviceaccjson,
                kubeconfig: state.kubeconfig,
              };
              fetch(`${process.env.REACT_APP_API_URL}/api/credentials/`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer " + window.localStorage.getItem("token"),
                },
                body: JSON.stringify(register),
              })
                .then((response) => response.json())
                .then((data) => {
                  if (data.name) {
                    setOpen(!open);
                    window.location.href = "/admin/credentials";
                  }
                })
                .catch((error) => {
                  console.error(error);
                  window.location.href = "/something_went_wrong";
                });
            }
          }
        } else {
          setState({
            errorMessage:
              "Special characters are not allowed in username field!",
          });
        }
      }
    } else {
      const register = {
        name: state.name,
        description: state.description,
        auth_method: "password",
        username: state.username,
        password: state.password,
        ssh_key: state.ssh_key,
        os_type: state.os_type,
        kerberos: state.kerberos,
        domain_name: state.domain_name,
        ad_server: state.ad_server,
        provider: state.provider,
        accesskeyid: state.accesskeyid,
        secretaccesskey: state.secretaccesskey,
        clientid: state.clientid,
        secret: state.secret,
        serviceaccjson: state.serviceaccjson,
        kubeconfig: state.kubeconfig,
      };
      fetch(`${process.env.REACT_APP_API_URL}/api/credentials/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
        body: JSON.stringify(register),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.name) {
            setOpen(!open);
            window.location.href = "/admin/credentials";
          }
        })
        .catch((error) => {
          console.error(error);
          window.location.href = "/something_went_wrong";
        });
    }
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/organizationcredentiallist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setCredlist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const Delete = (userId) => {
    return function () {
      fetch(`${process.env.REACT_APP_API_URL}/api/credentials/${userId}/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          window.top.location.reload(false);
        })
        .catch((error) => {
          console.log(error);
          window.location.reload();
        });
    };
  };

  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;

    if (event.target.checked) {
      newSelectedCustomerIds = credlist.map((cred) => cred.id);
    } else {
      newSelectedCustomerIds = [];
    }

    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCustomerIds.indexOf(id);
    let newSelectedCustomerIds = [];

    if (selectedIndex === -1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds,
        id
      );
    } else if (selectedIndex === 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(1)
      );
    } else if (selectedIndex === selectedCustomerIds.length - 1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, selectedIndex),
        selectedCustomerIds.slice(selectedIndex + 1)
      );
    }

    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const [open2, setOpen2] = useState(false);
  const [focusAfterClose2] = useState(true);
  const toggle2 = () => setOpen2(!open2);

  function del(deleteid) {
    setState({ delete_id: deleteid });
  }

  const handleClose = () => {
    setOpen(false);
  };
  const toggle = () => setOpen(!open);

  function refreshPage() {
    window.location.reload();
  }

  const unique = [
    ...new Set(
      credlist.sort((a, b) => (a.serial_number > b.serial_number ? -1 : 1))
    ),
  ];

  const [one, setone] = React.useState(false);

  const oneopen = () => {
    setone(true);
  };

  const oneClose = () => {
    setone(false);
  };

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const cloumnName = "name";
  return (
    <>
      <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
        <div className="relative flex flex-wrap items-stretch">
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search Credential name here..."
            onChange={(event) => {
              console.log(event.target.value);
              setSearchItems(event.target.value);
            }}
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
          />
        </div>
      </form>
      <br />
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
              
        <Dialog
          PaperProps={{
            sx: {
              width: "100%",
            },
          }}
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
                      
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
                        ADD CREDENTIALS             
          </h2>
                     {" "}
          <div>
            {state.errorMessage && (
              <Alert severity="error" isOpen={visible} toggle={onDismiss}>
                {" "}
                {state.errorMessage}{" "}
              </Alert>
            )}
          </div>
          <DialogContent>
            <FormGroup>
              <FormLabel htmlFor="name">
                <strong>Name</strong>
              </FormLabel>

              <TextField
                fullWidth
                type="text"
                id="name"
                className="form-control"
                value={state.name}
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Enter a name for the credential"
              />
            </FormGroup>
            <br />
            <FormGroup>
              <FormLabel htmlFor="description">
                <strong>Description</strong>
              </FormLabel>
              <TextField
                type="text"
                id="description"
                className="form-control"
                value={state.description}
                onChange={handleChange}
                placeholder="Short detail about the credential"
                variant="outlined"
                size="small"
                fullWidth
              />
            </FormGroup>
            <br />
            <Row>
              <Col>
    <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label"><strong>Type</strong></FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
      >
        <FormControlLabel control={
                <Radio
                checked={selectedValue === "os"}
                onChange={handleChange1}
                value="os"
                name="radio-button-demo"
                inputProps={{ "aria-label": "C" }}
              />
        } label="OS" />
        <FormControlLabel control={
                <Radio
                checked={selectedValue === "cloud"}
                onChange={handleChange1}
                value="cloud"
                name="radio-button-demo"
                inputProps={{ "aria-label": "C" }}
              />
        } label="CLOUD" />
        <FormControlLabel control={
               <Radio
               checked={selectedValue === "kubernetes"}
               onChange={handleChange1}
               value="kubernetes"
               name="radio-button-demo"
               inputProps={{ "aria-label": "C" }}
             />
        } label="KUBERNETES" />
      </RadioGroup>
    </FormControl>                
              </Col>
            </Row>
            <br />
            {selectedValue == "os" ? (
              <React.Fragment>
                <FormGroup>
                  <FormLabel htmlFor="os_type">
                    <strong> OS type</strong>
                        
                  </FormLabel>
                  <TextField
                    className="form-control"
                    type="select"
                    id="os_type"
                    placeholder="-- Choose the OS type --"
                    name="os_type"
                    value={state.os_type}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                    required
                    select
                    SelectProps={{ native: true }}
                  >
                      {" "}
                      <option>-- Search the OS Type --</option>
                      <option value="windows">Windows</option>
                      <option value="linux">Linux</option>
                  </TextField>
                </FormGroup>
                <br />
                <FormGroup>
                  <FormLabel htmlFor="username">
                     <strong>Username</strong>
                  </FormLabel>
                  <TextField
                    className="form-control"
                    type="text"
                    id="username"
                    placeholder="Enter the username"
                    name="username"
                    value={state.username}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <FormLabel htmlFor="username">
                    {state.os_type === "windows" ? (
                      <h5>
                        <strong>Hint:</strong> Administrator User is not
                        allowed, user with similar privillage is required
                      </h5>
                    ) : state.os_type === "linux" ? (
                      <h5>
                        <strong>Hint:</strong> Root User is not allowed, user
                        with similar privillage is required
                      </h5>
                    ) : (
                      ""
                    )}
                  </FormLabel>
                </FormGroup>
                <br />
                <FormGroup>
                  <FormLabel htmlFor="auth_method">
                    <strong>Authentication Method</strong>
                  </FormLabel>
                  <TextField
                    className="form-control"
                    type="select"
                    id="auth_method"
                    placeholder="Authentication Method"
                    name="username"
                    value={state.auth_method}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                    SelectProps={{ native: true }}
                    required
                    select
                  >
                      {" "}
                      
                    {state.os_type === "linux" ? (
                      <React.Fragment>
                              
                        <option>-- Select Authentication Method --</option>
                              
                        <option value="password">
                          Password Authentication
                        </option>
                              
                        <option value="sshkey">Key Based Authentication</option>
                        {" "}
                            
                      </React.Fragment>
                    ) : state.os_type === "windows" ? (
                      <React.Fragment>
                              
                        <option value="password">
                          Password Authentication
                        </option>
                            
                      </React.Fragment>
                    ) : (
                      ""
                    )}
                  </TextField>
                </FormGroup>
                <br />
                {state.auth_method === "password" ||
                state.os_type === "windows" ? (
                  <FormGroup>
                    <FormLabel htmlFor="password">
                      <strong>Password</strong>
                    </FormLabel>
                    <OutlinedInput
                      htmlFor="password"
                      placeholder="Enter the password ..."
                      type={state.showPassword ? "text" : "password"}
                      autoComplete="new-password"
                      name="password"
                      id="password"
                      className="form-control"
                      value={state.password}
                      onChange={handleChange}
                      size="small"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {state.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    {/* </InputGroup> */}
                  </FormGroup>
                ) : (
                  ""
                )}
                {state.os_type === "windows" ? (
                  <React.Fragment>
                      
                    <FormGroup>
                      <FormControlLabel
                        control={<Switch />}
                        label="Kerbose authentication"
                        onClick={showSubnav}
                      />
                    </FormGroup>
                    {subnav ? (
                      <React.Fragment>
                        <FormGroup>
                          <FormLabel htmlFor="domain name">
                             <strong>Domain Name</strong>
                          </FormLabel>
                          <TextField
                            className="form-control"
                            type="text"
                            id="domain_name"
                            placeholder="Enter the domain name"
                            name="domain_name"
                            value={state.domain_name}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        </FormGroup>
                        <br />
                        <FormGroup>
                          <FormLabel htmlFor="ad server">
                             <strong>AD Server</strong>
                          </FormLabel>
                          <TextField
                            className="form-control"
                            type="text"
                            id="ad_server"
                            placeholder="Enter the AD Server DNS hostname"
                            name="ad_server"
                            value={state.ad_server}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                          <FormLabel htmlFor="username">
                            <h5>
                              <strong>Hint:</strong> The AD Sserver should be
                              accessible by AutomateCIS for whitelisting contact
                              support
                            </h5>
                          </FormLabel>
                        </FormGroup>
                        <br />
                      </React.Fragment>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ) : (
                  ""
                )}
                {state.auth_method === "sshkey" ? (
                  <React.Fragment>
                      
                    <FormGroup>
                      <FormLabel htmlFor="ssh_key">
                         <strong>SSH_Key</strong>
                      </FormLabel>
                      <TextField
                        style={{ marginLeft: "32px", width: "86%" }}
                        multiline
                        rows={3}
                        htmlFor="ssh_key"
                        placeholder="Enter the ssh key ..."
                        type="text"
                        autoComplete="new-ssh_key"
                        name="ssh_key"
                        id="ssh_key"
                        className="form-control"
                        value={state.ssh_key}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                      <FormLabel htmlFor="ssh_key">
                         <strong>Hint:</strong>
                        Ensure you are giving the correct PEM key format
                      </FormLabel>
                    </FormGroup>
                      
                  </React.Fragment>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : selectedValue == "cloud" ? (
              <React.Fragment>
                <FormGroup style={{ marginBottom: "1.5rem" }}>
                  <FormLabel htmlFor="Cloud">
                    <strong>Provider</strong>
                  </FormLabel>
                  <TextField
                    className="form-control"
                    type="select"
                    id="provider"
                    placeholder="-- Select the Cloud --"
                    name="provider"
                    value={state.provider}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                    required
                    select
                    SelectProps={{ native: true }}
                  >
                    {" "}
                    <option>-- Select the Cloud Provider --</option>
                    <option value="aws">AWS</option>
                    <option value="azure">Azure</option>
                    <option value="gcp">GCP</option>
                  </TextField>
                </FormGroup>
                {state.provider == "aws" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="accesskeyid">
                        <strong>AccessKeyID</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="accesskeyid"
                        className="form-control"
                        value={state.accesskeyid}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder="Enter a accesskey id for aws"
                      />
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <FormLabel htmlFor="secretaccesskey">
                        <strong>SecretAccessKey</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="secretaccesskey"
                        className="form-control"
                        value={state.secretaccesskey}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder="Enter a secret access key for aws"
                      />
                    </FormGroup>
                  </React.Fragment>
                ) : state.provider == "azure" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="clientid">
                        <strong>Client ID</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="clientid"
                        className="form-control"
                        value={state.clientid}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder="Enter a client id for azure"
                      />
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <FormLabel htmlFor="secret">
                        <strong>Secret</strong>
                      </FormLabel>
                      <TextField
                        fullWidth
                        type="text"
                        id="secret"
                        className="form-control"
                        value={state.secret}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        placeholder="Enter a secret for azure"
                      />
                    </FormGroup>
                  </React.Fragment>
                ) : state.provider == "gcp" ? (
                  <React.Fragment>
                    <FormGroup>
                      <FormLabel htmlFor="serviceaccjson">
                         <strong>Service A/C Json</strong>
                      </FormLabel>
                      <TextField
                        // style={{ marginLeft: "15px", width: "90%" }}
                        multiline
                        rows={3}
                        htmlFor="serviceaccjson"
                        placeholder="Enter the json ..."
                        type="text"
                        autoComplete="new-serviceaccjson"
                        name="serviceaccjson"
                        id="serviceaccjson"
                        className="form-control"
                        value={state.serviceaccjson}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                      <FormLabel htmlFor="serviceaccjson">
                         <strong>Hint:</strong>
                        Ensure you are giving the correct Json for service
                        account
                      </FormLabel>
                    </FormGroup>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : selectedValue == "kubernetes" ? (
              <React.Fragment>
                <FormGroup>
                  <FormLabel htmlFor="kubeconfig">
                     <strong>Kube Config</strong>
                  </FormLabel>
                  <TextField
                    // style={{ marginLeft: "15px", width: "90%" }}
                    multiline
                    rows={3}
                    htmlFor="kubeconfig"
                    placeholder="Enter the kube config ..."
                    type="text"
                    autoComplete="new-kubeconfig"
                    name="kubeconfig"
                    id="kubeconfig"
                    className="form-control"
                    value={state.kubeconfig}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                  <FormLabel htmlFor="kubeconfig">
                     <strong>Hint:</strong>
                    Ensure you are giving the correct config for cluster
                  </FormLabel>
                </FormGroup>
              </React.Fragment>
            ) : (
              ""
            )}{" "}  
          </DialogContent>
          <DialogActions>
            <button
              className="bg-blueGray-100 text-black font-bold active:bg-blueGray-600 uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={() => refreshPage()}
            >
              Cancel
            </button>
            <button
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={handleSubmitClick}
            >
              Create
            </button>
          </DialogActions>
                
        </Dialog>
        <Card>
          <CardHeader
            action={
              <React.Fragment>
                <button
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                  style={{ float: "right" }}
                  onClick={handleClickOpen}
                >
                  Add Credential
                </button>
              </React.Fragment>
            }
            title="CREDENTIAL LIST"
          />
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell align="center">S.No</TableCell>
                    <TableCell align="center">Name</TableCell>
                    <TableCell align="center">Type</TableCell>
                    <TableCell align="center">Method</TableCell>
                    {window.localStorage.getItem("audit_run_access") ===
                    "You do not have permission to perform this action." ? (
                      ""
                    ) : (
                      <React.Fragment>
                        <TableCell align="center">Edit</TableCell>
                        <TableCell align="center">Delete</TableCell>
                      </React.Fragment>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {unique
                    .slice(page * limit, page * limit + limit)
                    .filter((val) => {
                      if (searchitems == "") {
                        return val;
                      } else if (
                        val[cloumnName]
                          .toLowerCase()
                          .includes(searchitems.toLowerCase())
                      ) {
                        return val;
                      }
                    })
                    .map((cred) => (
                      <TableRow
                        hover
                        key={cred.id}
                        selected={selectedCustomerIds.indexOf(cred.id) !== -1}
                      >
                        <TableCell align="center">
                          {cred.serial_number}{" "}
                        </TableCell>
                        <TableCell align="center">{cred.name}</TableCell>
                        <TableCell align="center">{cred.provider}</TableCell>
                        <TableCell align="center">
                        {cred.provider === "os" ? [ cred.auth_method ? cred.auth_method : "-" ] : "-"}
                        </TableCell>
                        {window.localStorage.getItem("audit_run_access") ===
                        "You do not have permission to perform this action." ? (
                          ""
                        ) : (
                          <React.Fragment>
                            <TableCell align="center">
                              <EditCred CredID={cred.id} />
                            </TableCell>
                            <TableCell align="center">
                              <IconButton
                                title="Delete"
                                aria-label="delete"
                                id="delete"
                                style={{
                                  padding: "0px",
                                  color: "#e68383",
                                }}
                              >
                                <DeleteIcon
                                  fontSize="small"
                                  onClick={() => {
                                    oneopen();
                                    window.sessionStorage.setItem(
                                      "credentialname",
                                      cred.name
                                    );
                                    del(cred.id);
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          </React.Fragment>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <TablePagination
            component="div"
            count={credlist.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Card>
        <Dialog
          open={one}
          fullWidth
          TransitionComponent={Transition}
          keepMounted
          onClose={oneClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "810",
              color: "rgb(48, 68, 115)",
              fontFamily: "sans-serif",
              lineHeight: "4.5rem",
            }}
          >
            DELETE CREDENTIALS
          </h2>

          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to delete{" "}
              <strong>{window.sessionStorage.getItem("credentialname")}</strong>{" "}
              ?{" "}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <button
              className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={() => refreshPage()}
              size="sm"
            >
              Cancel
            </button>
            <button
              className="bg-red-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              onClick={Delete(state.delete_id)}
            >
              Delete
            </button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}